import { useEffect, useState } from 'react';
import styles from './Projects.module.css'
import TypeProject from './TypeProject/TypeProject'
import ProjectsList from './ProjectsList/ProjectsList';
import { ProjectInterface } from '../../lib/types/project';
import { sanityClient } from '../../lib/sanity.client';
import { ProjectTypes } from '../../lib/types/projectTypes';
import { useTranslation } from '../../TranslationProvider';

export type ProjetsProps = {
    setIsFooterVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    search: string;
    setProjectTitle: React.Dispatch<React.SetStateAction<string>>;
    setHoverProject: React.Dispatch<React.SetStateAction<boolean>>;
}

const Projects = (props: ProjetsProps) => {

    const { currLang } = useTranslation(); // ✅ use context here
    const [projects, setProjects] = useState<ProjectInterface[]>([]);
    const [projectsTypes, setProjectsTypes] = useState<ProjectTypes[]>([]);

      useEffect(() => {
        props.setIsFooterVisible(true);
        window.scrollTo(0, 0);
const query = `*[
  _type == "project" &&
  (
    $filter == "" || $filter in typeProject[]->type[$lang]
  )
]{
  ...,
  typeProject[]->{
    type
  }
}`;
      
        // search and search length, so it search even when search is empty
        (sanityClient as any)
          .fetch(query, { 
            lang: currLang,
            filter: props.search, 
          })
          .then((data: ProjectInterface[]) => {
            setProjects(data);
          })
          .catch(console.error);
      }, [props.search]);

    useEffect(() => {
        (sanityClient as any).fetch(`*[_type == "typeProject" && showType == "Visible"]{
    ...
}`)
            .then((data : ProjectTypes[]) => {
                setProjectsTypes(data)
            })
            .catch(console.error)
    }, []);

    return (
        <div className={styles.section}>
            <div className={styles.type_project}>
                <TypeProject type={""} search={props.search} setSearch={props.setSearch} />
                {projectsTypes.map((data, index) => (
                    <TypeProject key={index} type={data.type[currLang]} search={props.search} setSearch={props.setSearch} />
                ))}
            </div>
            <div className={styles.list_projects}>
                <ProjectsList setProjectTitle={props.setProjectTitle} setHoverProject={props.setHoverProject} projects={projects} />
            </div>
        </div>
    )
}


export default Projects
